import { render } from "./Item7.vue?vue&type=template&id=0ecb9a32&ts=true"
import script from "./Item7.vue?vue&type=script&lang=ts"
export * from "./Item7.vue?vue&type=script&lang=ts"

import exportComponent from "/Users/ittiwutwongsawat/Documents/GitHub/clinic/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__